export default "__VITE_PUBLIC_ASSET__9395a5ea__"